import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-43cf812a")

_pushScopeId("data-v-43cf812a")
const _hoisted_1 = { class: "profile-icon" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("picture", null, [
      _createVNode("img", {
        src: _ctx.imageSource,
        alt: "プロフィール画像",
        onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.useFallbackImage && _ctx.useFallbackImage(...args)))
      }, null, 40, ["src"])
    ])
  ]))
})